import React from 'react';
import { sistemaTotalRows, metodoFeatures } from '../data/comparaciones';
import { Emoji } from './Emoji';
export function SistemaTotal() {
  return <section className="w-full bg-canvas py-14 sm:py-16" data-id="element-210" data-mp="n4evf67e4ai8">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[980px]" data-id="element-211" data-mp="10yy39x63s67x">
        <p className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold-700 sm:text-sm" data-id="element-212" data-mp="w6xtze4580yo">
          <Emoji symbol="🏆" data-id="element-213" data-mp="15x9cc5okqcp3" />
          Solo en MegaPack + El Método 80/20
        </p>
        <h2 className="mt-3 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold leading-[1.08] tracking-tight text-ink-900" data-id="element-214" data-mp="1jws8e0441xl1">
          ¿Qué agrega El Método 80/20?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-ink-500 sm:text-base" data-id="element-215" data-mp="1ft2k7brcli0j">
          El Método 80/20 es el upgrade científico que hace que todo lo del
          MegaPack funcione al máximo. No es solo cocinar bien — es hacer que tu
          cuerpo aproveche el 100% de lo que comés.
        </p>

        <ul className="mt-9 grid gap-4 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-216" data-mp="7qjmlgp5dqlp">
          {metodoFeatures.map(feature => <li key={feature.title} className="h-full" data-id="element-217" data-mp="couwfrfg013x">
              <article className="flex h-full flex-col rounded-2xl border border-line bg-white px-5 py-5 shadow-card sm:px-6 sm:py-6" data-id="element-218" data-mp="co320jxl09f8">
                <Emoji symbol={feature.emoji} className="text-3xl" data-id="element-219" data-mp="mgh2l9cxb9zt" />
                <h3 className="mt-4 font-display text-[15px] font-extrabold leading-snug text-ink-900 sm:text-base" data-id="element-220" data-mp="qhaqi2qd8osp">
                  {feature.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-ink-500 sm:text-[14px]" data-id="element-221" data-mp="vh6yse63j2e2">
                  {feature.description}
                </p>
              </article>
            </li>)}
        </ul>

        <h3 className="mt-14 font-display text-[clamp(1.25rem,5vw,1.75rem)] font-extrabold leading-tight tracking-tight text-ink-900" data-id="element-222" data-mp="2xa3gukyfb57o">
          ¿Qué lo diferencia de solo tener el MegaPack?
        </h3>

        <ul className="mt-8 grid gap-4 text-left lg:grid-cols-2" data-id="element-223" data-mp="2q4k74sfm929l">
          {sistemaTotalRows.map(row => <li key={row.situation} className="flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-card" data-id="element-224" data-mp="344225pji9bre">
              <p className="bg-celeste-100 px-4 py-4 font-display text-[14px] font-bold text-ink-900 sm:px-5 sm:text-[15px]" data-id="element-225" data-mp="2z7lcgqwnqpc7">
                {row.situation}
              </p>
              <div className="flex items-start gap-3 border-b border-line px-4 py-4 sm:px-5" data-id="element-226" data-mp="392wqt845lujf">
                <Emoji symbol="❌" className="mt-0.5" data-id="element-227" data-mp="3mubcjmpg49u6" />
                <span className="min-w-0 text-[14px] text-ink-500 sm:text-[15px]" data-id="element-228" data-mp="3hvzyt0w15f6o">
                  <span className="font-semibold text-red-600" data-id="element-229" data-mp="nmk1mpbk15b">
                    Sin El Método 80/20:{' '}
                  </span>
                  {row.without}
                </span>
              </div>
              <div className="flex items-start gap-3 px-4 py-4 sm:px-5" data-id="element-230" data-mp="fal7z7oywdfa">
                <Emoji symbol="✅" className="mt-0.5" data-id="element-231" data-mp="f87hlc58fpe2" />
                <span className="min-w-0 text-[14px] font-medium text-ink-900 sm:text-[15px]" data-id="element-232" data-mp="javqfjty4wb1">
                  <span className="font-bold text-celeste-700" data-id="element-233" data-mp="5b2pywsmb1pv">
                    Con El Método 80/20:{' '}
                  </span>
                  {row.with}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}